<template>
  <div id="app" style="user-select: none;">
    <!--    <div id="nav">-->
    <!--      <router-link to="/">Home</router-link> |-->
    <!--      <router-link to="/about">About</router-link>-->
    <!--    </div>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router-view">
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router-view" ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {};
  },
  methods: {
    // 阻止双击放大
    // let lastTouchEnd = 0;
    // document.addEventListener('touchstart', function (event) {
    //   if (event.touches.length > 1) {
    //     event.preventDefault();
    //   }
    // });
    // document.addEventListener('touchend', function (event) {
    //   let now = (new Date()).getTime();
    //   if (now - lastTouchEnd <= 300) {
    //     event.preventDefault();
    //   }
    //   lastTouchEnd = now;
    // }, false);

    // 阻止双指放大
    banGesture: function () {
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault();
      });
      document.addEventListener('touchstart', function() {}, false);
    },
  },
  mounted() {
    this.banGesture();
  },
  created() {
  },
  destroyed() {
  }
}
</script>
<style>
@import "assets/font/font.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
